import React from "react";
import { Link } from "react-router-dom"; // Import Link for routing
import { Card, Typography } from "antd";
const { Title, Text } = Typography;

const FundCard = ({ id, name, type, amc, logo }) => {
  return (
    <div
      style={{
        margin: "0 auto", // Center the card horizontally
        width: "90%", // Make the card span 80% of the screen width
      }}
    >
      <Link to={`/fund-details/${id}`} style={{ textDecoration: "none" }}>
        <Card
          style={{
            maxWidth: "1500px",
            borderRadius: "8px",
            padding: "16px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow for better visuals
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            {/* Logo Section */}
            {logo ? (
              <img
                src={logo}
                alt={`${name} logo`}
                style={{
                  width: "90px",
                  height: "48px",
                  borderRadius: "8px",
                  objectFit: "cover",
                }}
              />
            ) : (
              <div
                style={{
                  width: "90px",
                  height: "48px",
                  borderRadius: "8px",
                  backgroundColor: "#f0f0f0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text type="secondary" style={{ fontSize: "10px" }}>
                  No Logo
                </Text>
              </div>
            )}

            {/* Content Section */}
            <div style={{ display: "flex", width: "100%" }}>
              {/* Left Section */}
              <div style={{ flex: 3 }}>
                <Title level={4} style={{ margin: 0 }}>
                  {name}
                </Title>
                <Text type="secondary">
                  Create wealth with equities, stay protected with Gold. The
                  sweet spot
                </Text>
              </div>

              {/* Right Section */}
              <div
                style={{
                  flex: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ textAlign: "left", width: "50%" }}>
                  <Text type="secondary">AMC</Text>
                  <Title level={5} style={{ margin: 0 }}>
                    {amc}
                  </Title>
                </div>
                <div style={{ textAlign: "left", width: "50%" }}>
                  <Text type="secondary">Type of Fund</Text>
                  <Title level={5} style={{ margin: 0, color: "#52c41a" }}>
                    {type}
                  </Title>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </Link>
    </div>
  );
};

export default FundCard;
